import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=7a8a0a05&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=7a8a0a05&prod&scoped=true&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=7a8a0a05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8a0a05",
  null
  
)

export default component.exports